<template>
  <g id="canvas-legend">
    <line class="legend-left-end" :x1="svgPadding" :x2="svgPadding" :y1="(yBottom-20)" :y2="yBottom" :stroke="cssVariables.sakaOrange" stroke-width="1" />
    <line class="legend-right-end" :x1="(isPigtail ? (svgWidth/2) : (svgWidth - svgPadding))" :x2="(isPigtail ? (svgWidth/2) : (svgWidth - svgPadding))" :y1="(yBottom-20)" :y2="yBottom" :stroke="cssVariables.sakaOrange" stroke-width="1" />
    <polygon class="legend-left-indicator" :points="leftIndicator" :fill="cssVariables.sakaOrange" :stroke="cssVariables.sakaOrange" stroke-width="1" />
    <polygon class="legend-right-indicator" :points="rightIndicator" :fill="cssVariables.sakaOrange" :stroke="cssVariables.sakaOrange" stroke-width="1" />
    <line class="legend-width-linex" :x1="svgPadding" :x2="(isPigtail ? (svgWidth/2) : (svgWidth - svgPadding))" :y1="yBottom" :y2="yBottom" :stroke="cssVariables.sakaOrange" stroke-width="1" />
  </g>
</template>

<script>
// we need to work with imported variables here to have 
//      1.) a centralized setup via scss
//      2.) explicitly set colors for external systems (report generator)
import variables from '@/variables.scss'

export default {
  props: {
    svgWidth: Number,
    svgPadding: Number,
    svgHeight: Number,
    isPigtail: Boolean,
    little: String
  },
  computed: {
    // svg stuff 
    // left arrow position
    leftIndicator () {
      return `${this.svgPadding},${this.yBottom} ${(this.svgPadding + this.arrowSize)},${(this.yBottom - this.arrowSize/2)}  ${(this.svgPadding + this.arrowSize)},${(this.yBottom + this.arrowSize/2)}`
    },
    // right arrow position
    rightIndicator () {
      if (this.isPigtail) return `${(this.svgWidth / 2)},${this.yBottom} ${((this.svgWidth / 2) - this.arrowSize)},${(this.yBottom - this.arrowSize/2)} ${((this.svgWidth / 2) - this.arrowSize)},${(this.yBottom + this.arrowSize/2)}`
      return `${(this.svgWidth - this.svgPadding)},${this.yBottom} ${(this.svgWidth - this.svgPadding - this.arrowSize)},${(this.yBottom - this.arrowSize/2)} ${(this.svgWidth - this.svgPadding - this.arrowSize)},${(this.yBottom + this.arrowSize/2)}`
    },
    yBottom () {
      return this.svgHeight - this.arrowSize
    }
  },
  data () {
    return {
      arrowSize: 6,
      cssVariables: variables
    }
  }
}
</script>